export default {
  inTag: 'in tag',
  inComment: 'in comment',
  inText: 'in text',
  inScript: 'in script',
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/tokenizer/States.js